import script from "./DonateCardDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./DonateCardDetails.vue?vue&type=script&setup=true&lang=js"

import "./DonateCardDetails.vue?vue&type=style&index=0&id=48ce1751&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48ce1751"]])

export default __exports__